"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var http_1 = require("@angular/http");
var DynamicBase_1 = require("./DynamicBase");
var DynamicCache_1 = require("./DynamicCache");
var DynamicDirective = (function (_super) {
    __extends(DynamicDirective, _super);
    function DynamicDirective(dynamicExtraModules, viewContainer, compiler, http, dynamicCache) {
        return _super.call(this, dynamicExtraModules, viewContainer, compiler, http, dynamicCache, '[dynamic-component-{id}]') || this;
    }
    return DynamicDirective;
}(DynamicBase_1.DynamicBase));
DynamicDirective.decorators = [
    { type: core_1.Directive, args: [{
                selector: '[dynamic-component]'
            },] },
];
/** @nocollapse */
DynamicDirective.ctorParameters = function () { return [
    { type: Array, decorators: [{ type: core_1.Inject, args: [DynamicBase_1.DYNAMIC_TYPES.DynamicExtraModules,] },] },
    { type: core_1.ViewContainerRef, decorators: [{ type: core_1.Inject, args: [core_1.ViewContainerRef,] },] },
    { type: core_1.Compiler, decorators: [{ type: core_1.Inject, args: [core_1.Compiler,] },] },
    { type: http_1.Http, decorators: [{ type: core_1.Inject, args: [http_1.Http,] },] },
    { type: DynamicCache_1.DynamicCache, decorators: [{ type: core_1.Inject, args: [DynamicCache_1.DynamicCache,] },] },
]; };
DynamicDirective.propDecorators = {
    'dynamicComponentReady': [{ type: core_1.Output },],
    'dynamicComponentBeforeReady': [{ type: core_1.Output },],
    'componentType': [{ type: core_1.Input },],
    'componentTemplate': [{ type: core_1.Input },],
    'componentStyles': [{ type: core_1.Input },],
    'componentContext': [{ type: core_1.Input },],
    'componentTemplateUrl': [{ type: core_1.Input },],
    'componentTemplatePath': [{ type: core_1.Input },],
    'componentDefaultTemplate': [{ type: core_1.Input },],
    'componentRemoteTemplateFactory': [{ type: core_1.Input },],
    'componentModules': [{ type: core_1.Input },],
};
exports.DynamicDirective = DynamicDirective;
//# sourceMappingURL=DynamicDirective.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-dynamic-component/DynamicDirective.js
// module id = 208
// module chunks = 3